import { ComponentProps, ForwardedRef, forwardRef } from 'react';

import { OptionList, SearchSelect, SimpleSelectTrigger } from '@ingrid/luterkort-react';

type SearchSelectRootProps = ComponentProps<typeof SearchSelect.Root>;

export type SimpleSearchSelectProps = {
  invalid?: boolean;
  options: [string, string][];
  placeholder?: string;
  'data-testid'?: string;
} & Pick<SearchSelectRootProps, 'onValueChange' | 'value'>;

function SimpleSearchSelectElement(
  { invalid, options, placeholder, ...rootProps }: SimpleSearchSelectProps,
  ref: ForwardedRef<HTMLButtonElement>
) {
  return (
    <SearchSelect.Root shouldCloseOnSelect={true} {...rootProps}>
      <SearchSelect.Trigger data-testid={rootProps['data-testid']} data-invalid={invalid} ref={ref} asChild>
        <SimpleSelectTrigger options={options} placeholder={placeholder ?? ''} />
      </SearchSelect.Trigger>

      <SearchSelect.Content style={{ minWidth: '480px' }}>
        <OptionList.Viewport style={{ maxHeight: '400px' }}>
          {options.map(option => (
            <OptionList.Item key={option[0]} value={option[0]}>
              <OptionList.ItemText>{option[1]}</OptionList.ItemText>
              <OptionList.ItemIndicator />
            </OptionList.Item>
          ))}
        </OptionList.Viewport>
      </SearchSelect.Content>
    </SearchSelect.Root>
  );
}

export const SimpleSearchSelect = forwardRef(SimpleSearchSelectElement);
